module.exports = "<div seedelement><slot></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-stepper/theme/lui-stepper.html
// module id = 331
// module chunks = 0 1 7